import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { Actions, Getters, Mutations, AppState } from '@/interfaces/store/app'
import { RootState } from '@/interfaces/store/root'

export const state: AppState = {
  isLoadingHome: true,
  isLoadingPoints: false,
  loadingBarLabelHtml: ''
}

export const getters: GetterTree<AppState, RootState> & Getters = {}

export const actions: ActionTree<AppState, RootState> & Actions = {}

export const mutations: MutationTree<AppState> & Mutations = {
  setIsLoadingHome(state: AppState, value: boolean) {
    state.isLoadingHome = value
  },
  setIsLoadingPoints(state: AppState, value: boolean) {
    state.isLoadingPoints = value
  },
  setLoadingBarLabelHtml(state: AppState, value: string) {
    state.loadingBarLabelHtml = value
  }
}

export const store: Module<AppState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
